import React, {FunctionComponent} from 'react'
import {useTranslation} from 'react-i18next'
import {IDayResult} from '../../Client/IResult'
import DateFormats from '../../../../App/Helpers/DateFormats'
import MoneyFormatter from '../../../../App/Helpers/MoneyFormatter'
import { IProps } from './IProps'

const Body: FunctionComponent<IProps> = ({result}) => {
    const {t} = useTranslation()
    const getRow = (dayResult: IDayResult, vatPercentages: number[], index: number) => {
        return <tr key={'dayResultRow' + dayResult.date.format('YYYYMMDD') + index}>
            <td key={'Date'} >{dayResult.date.format(DateFormats.DATE_FORMAT_LONG)}</td>
            <td key={'Description'} >{t('Day receipts')}</td>
            <td key={'Totals'} className={'text-right'}>{MoneyFormatter.format(dayResult.total)}</td>
            {vatPercentages.map(
                (vatPercentage: number) => {
                    return <td key={`vat${vatPercentage}`} className={'text-right'}>
                        {
                            dayResult.vatPercentages[vatPercentage]
                                ? MoneyFormatter.format(dayResult.vatPercentages[vatPercentage])
                                : null
                        }
                    </td>
                }
            )}
        </tr>
    }

    return <tbody>
        {result.dayResults.map((dayResult, index) => getRow(dayResult, result.vatPercentages, index))}
    </tbody>
}

export default Body
